import {Component, OnInit} from '@angular/core';
import {ListItem} from '../models/list-item';
import {ActivatedRoute} from '@angular/router';
import * as fromRoot from '../reducers';
import * as actions from '../actions/list';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';

@Component({
  selector: 'app-list-item-editor',
  template: `<div class="row justify-content-center">
      <div class="col-md-12">
          <div class="card">
              <div class="card-header">
                  <h6>Edit List Item</h6>
              </div>
              <div class="card-body">
                  <list-item-editor-form [listItem]="listItem$ | async" 
                                         (saveListItem)="save($event)"
                                         [parentId]="parentId"
                                         [working]="working$ | async"
                                         [itemId]="itemId"></list-item-editor-form>
              </div>
          </div>
      </div>
  </div>
  `
})
export class ListItemEditorPageComponent implements OnInit {
  public parentId: number;
  public itemId: number;
  public listItem$: Observable<ListItem>;
  public working$: Observable<boolean>;
  constructor(private route: ActivatedRoute,
              private store: Store<fromRoot.State>) {
    this.listItem$ = this.store.select(fromRoot.getCurrentListItem);
    this.working$ = this.store.select(fromRoot.getListWorking);
  }

  save(li: ListItem) {
    this.store.dispatch(new actions.SaveListItemAction(li));
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.itemId = +params['id'];
      this.parentId = +params['parentId'];
      if (this.itemId && this.itemId > 0) {
        this.store.dispatch(new actions.LoadListItemAction(this.itemId));
      }
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/containers/list-item-editor.ts